import css from './Chat.module.css'

export const styles = {
    chat: css['chat'],
    content: css['chat__content'],
    textArea: css['chat__textarea'],
    footer: css['chat__footer'],
    iconContainer: css['chat__icon-container'],
    divider: css['chat__divider']
}